export default __webpack_public_path__ + "static/media/hubspotIcon.164148c7.svg";